var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgRuler = function SvgSvgRuler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    fill: "none",
    viewBox: "0 0 24 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.75 18a2.25 2.25 0 0 1-2.25-2.25V9H2.25A2.25 2.25 0 0 1 0 6.75v-4.5A2.25 2.25 0 0 1 2.25 0h21a1 1 0 0 1 .108.009l.067.012q.039.01.074.022a.6.6 0 0 1 .128.06.6.6 0 0 1 .085.055c.025.02.039.034.053.048a.666.666 0 0 1 .086.096l.039.058a.7.7 0 0 1 .099.27l.008.078C24 .726 24 .733 24 .75v15A2.25 2.25 0 0 1 21.75 18zM18 15.75c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75V2.888L18 8.513zM16.89 7.5l4.8-6h-5.94V3a.75.75 0 0 1-1.5 0V1.5h-3V3a.75.75 0 0 1-1.5 0V1.5h-3V3a.75.75 0 0 1-1.5 0V1.5h-3a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75H3V6a.75.75 0 0 1 1.5 0v1.5h3V6A.75.75 0 0 1 9 6v1.5h3V6a.75.75 0 0 1 1.5 0v1.5z"
  })));
};
export default SvgSvgRuler;